// Centralized mock data for Blue Mountain Group — Security Training & Advisory

export const currentUser = {
    id: "u_001",
    name: "Leslie Alexander",
    username: "leslie_a",
    email: "leslie@bluemountain.io",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&auto=format",
    bio: "Operations Manager and former CP officer. Building skill-mastery routines for the next generation of security professionals.",
    joinedAt: "2024-09-12",
};

export const categories = [
    "All",
    "Cybersecurity",
    "Close Protection",
    "Travel Safety",
    "Tactical",
    "Risk Management",
    "Maritime",
];

// 24 security industry courses
export const courses = [
    {
        id: "c_001",
        title: "Close Protection Operations — Foundations",
        category: "Close Protection",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "The complete operator pipeline. Embus/debus drills, foot formations, advance recce, threat assessment and principal handling — taught to UK BTEC Level 3 standards.",
        price: 499,
        originalPrice: 999,
        salePercent: 50,
        rating: 4.9,
        ratingsCount: 1288,
        students: 8124,
        durationHours: 38,
        enrolled: true,
        progress: 62,
    },
    {
        id: "c_002",
        title: "Cybersecurity Fundamentals for Operators",
        category: "Cybersecurity",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "From phishing to zero trust. Build the digital hygiene every modern security operator needs — encrypted comms, OPSEC, device hardening, insider-threat awareness.",
        price: 249,
        originalPrice: 499,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 2104,
        students: 14502,
        durationHours: 16,
        enrolled: true,
        progress: 35,
    },
    {
        id: "c_003",
        title: "Lone Traveller Safety & Personal Resilience",
        category: "Travel Safety",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Designed for journalists, NGO workers and frequent business travellers. Pre-trip planning, situational awareness, hotel security, hostile-environment first response.",
        price: 199,
        originalPrice: 399,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 944,
        students: 10240,
        durationHours: 12,
        enrolled: true,
        progress: 88,
    },
    {
        id: "c_004",
        title: "Hostile Environment Awareness Training (HEAT)",
        category: "Travel Safety",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1591608971362-f08b2a75731a?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1591608971362-f08b2a75731a?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Full immersive HEAT programme — checkpoints, IED awareness, kidnap survival, conflict media. Aligned with UN/UNDSS and INSO field standards.",
        price: 899,
        originalPrice: 1799,
        salePercent: 50,
        rating: 4.9,
        ratingsCount: 612,
        students: 3120,
        durationHours: 28,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_005",
        title: "Threat & Risk Assessment Methodology",
        category: "Risk Management",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "ASIS-aligned framework for analysing threats, evaluating likelihood and impact, prioritising mitigations and producing executive-ready risk registers.",
        price: 349,
        originalPrice: 699,
        salePercent: 50,
        rating: 4.6,
        ratingsCount: 720,
        students: 6440,
        durationHours: 18,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_006",
        title: "Counter-Surveillance Techniques",
        category: "Tactical",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Recognise, document and lose hostile surveillance. Foot/mobile detection, anti-rec drills, route analysis, technical surveillance counter-measures (TSCM) basics.",
        price: 449,
        originalPrice: 899,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 538,
        students: 4180,
        durationHours: 22,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_007",
        title: "Defensive & Evasive Driving",
        category: "Tactical",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Limit-handling, J-turns, ramming techniques, motorcade drills and ambush escape. Theory plus track-day footage and decision-trees for high-risk routes.",
        price: 599,
        originalPrice: 1199,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 462,
        students: 3680,
        durationHours: 14,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_008",
        title: "Maritime Security Operations (PMSC)",
        category: "Maritime",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "ISO 28007-aligned training. HRA transit planning, citadel doctrine, weapons-on-board legality, anti-piracy drills and post-incident reporting.",
        price: 749,
        originalPrice: 1499,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 318,
        students: 2480,
        durationHours: 24,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_009",
        title: "Executive Protection Driving",
        category: "Close Protection",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "From principal-vehicle protocols to convoy command. The driver as a force multiplier in modern executive protection.",
        price: 549,
        originalPrice: 1099,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 284,
        students: 2120,
        durationHours: 16,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_010",
        title: "Crisis Communications & Media Handling",
        category: "Risk Management",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "What you say in the first 60 minutes shapes everything that follows. Holding statements, media bridging, social-media triage and stakeholder mapping.",
        price: 299,
        originalPrice: 599,
        salePercent: 50,
        rating: 4.6,
        ratingsCount: 412,
        students: 5210,
        durationHours: 10,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_011",
        title: "Conflict Management & De-escalation",
        category: "Tactical",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1576267423445-b2e0074d68a4?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1576267423445-b2e0074d68a4?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "BTEC-aligned course on verbal de-escalation, body language, dynamic risk assessment and lawful use of reasonable force.",
        price: 179,
        originalPrice: 359,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 938,
        students: 11020,
        durationHours: 8,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_012",
        title: "First Aid for Security Professionals (FPOS-I)",
        category: "Tactical",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "First Person on Scene Intermediate. Catastrophic bleeding, tourniquet application, primary survey, casualty handover under operational pressure.",
        price: 229,
        originalPrice: 459,
        salePercent: 50,
        rating: 4.9,
        ratingsCount: 1102,
        students: 14080,
        durationHours: 12,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_013",
        title: "Surveillance & Reconnaissance",
        category: "Tactical",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Foot-team formations, vehicle surveillance, target-elicitation, log keeping and admissible evidence procedures.",
        price: 399,
        originalPrice: 799,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 388,
        students: 2940,
        durationHours: 20,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_014",
        title: "Counter-Terrorism Awareness",
        category: "Risk Management",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1606189934846-a527add8a77b?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1606189934846-a527add8a77b?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "ACT-Awareness aligned. Recognise hostile reconnaissance, suspicious behaviour, marauding-attack response and run-hide-tell drills.",
        price: 149,
        originalPrice: 299,
        salePercent: 50,
        rating: 4.6,
        ratingsCount: 1640,
        students: 22400,
        durationHours: 6,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_015",
        title: "Physical Security & Access Control",
        category: "Risk Management",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1568234928966-359c35dd8327?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1568234928966-359c35dd8327?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Layered defence, perimeter design, CPTED principles, access-control systems and CCTV strategy for corporate sites.",
        price: 329,
        originalPrice: 659,
        salePercent: 50,
        rating: 4.5,
        ratingsCount: 502,
        students: 4810,
        durationHours: 14,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_016",
        title: "OSINT for Security Operators",
        category: "Cybersecurity",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Open-source intelligence for protective and investigative work. SOCMINT, GEOINT, sock puppets, source validation and reporting.",
        price: 379,
        originalPrice: 759,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 644,
        students: 5100,
        durationHours: 18,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_017",
        title: "Crowd Management & Event Security",
        category: "Tactical",
        level: "Beginner",
        thumbnail: "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Crowd dynamics, pinch-point modelling, ingress/egress planning and incident command for live events of all sizes.",
        price: 219,
        originalPrice: 439,
        salePercent: 50,
        rating: 4.5,
        ratingsCount: 388,
        students: 4720,
        durationHours: 10,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_018",
        title: "Kidnap & Ransom Response",
        category: "Risk Management",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1585776245991-cf89dd7fc73a?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1585776245991-cf89dd7fc73a?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "K&R policy design, response-team activation, family-liaison protocols, proof-of-life management and post-recovery reintegration.",
        price: 699,
        originalPrice: 1399,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 184,
        students: 1240,
        durationHours: 16,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_019",
        title: "Active Shooter Response",
        category: "Tactical",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1564131073-86d3f24b5fcf?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1564131073-86d3f24b5fcf?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "AVOID-DENY-DEFEND framework, shelter-in-place strategy, triage of mass-casualty incidents and law-enforcement handover.",
        price: 269,
        originalPrice: 539,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 802,
        students: 9120,
        durationHours: 8,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_020",
        title: "Penetration Testing Fundamentals",
        category: "Cybersecurity",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Reconnaissance, exploitation, post-exploitation and reporting. Hands-on labs across web, network and Active Directory targets.",
        price: 649,
        originalPrice: 1299,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 1240,
        students: 8420,
        durationHours: 32,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_021",
        title: "SOC Analyst Bootcamp",
        category: "Cybersecurity",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Tier-1 SOC playbooks, SIEM tuning, incident triage, MITRE ATT&CK mapping and rotation-shift hygiene.",
        price: 549,
        originalPrice: 1099,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 968,
        students: 7220,
        durationHours: 26,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_022",
        title: "ISO 27001 Lead Implementer",
        category: "Risk Management",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Build and run an ISMS to ISO/IEC 27001:2022. Scope, risk assessment, Statement of Applicability, audits and certification readiness.",
        price: 799,
        originalPrice: 1599,
        salePercent: 50,
        rating: 4.8,
        ratingsCount: 412,
        students: 3120,
        durationHours: 30,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_023",
        title: "Travel Risk Management",
        category: "Travel Safety",
        level: "Intermediate",
        thumbnail: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Build a duty-of-care programme. Pre-trip risk briefs, journey management plans, tracking technology and post-incident follow-through.",
        price: 379,
        originalPrice: 759,
        salePercent: 50,
        rating: 4.6,
        ratingsCount: 528,
        students: 4520,
        durationHours: 14,
        enrolled: false,
        progress: 0,
    },
    {
        id: "c_024",
        title: "Counter-Drone & Aerial Threat Awareness",
        category: "Tactical",
        level: "Advanced",
        thumbnail: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=940&auto=format&fit=crop",
        cover: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?w=1600&auto=format&fit=crop",
        instructor: { name: "Nige Thomas", title: "BMG Course Instructor", avatar: "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/vk6t5pbv_Screenshot%202026-04-30%20114414.png" },
        description: "Detection, identification and lawful response to UAS threats. Geo-fencing, RF detection, anti-drone tactics and incident reporting.",
        price: 459,
        originalPrice: 919,
        salePercent: 50,
        rating: 4.7,
        ratingsCount: 184,
        students: 1620,
        durationHours: 12,
        enrolled: false,
        progress: 0,
    },
];

// Curriculum / lessons keyed by course id
export const curricula = {
    c_001: [
        {
            stage: "Stage 1: Foundations of Close Protection",
            lessons: [
                { id: "l_1_1", title: "Role of the Modern CP Operator", duration: "08:12", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" },
                { id: "l_1_2", title: "Threat & Risk Assessment Basics", duration: "15:30", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4" },
            ],
        },
        {
            stage: "Stage 2: Foot Drills & Formations",
            lessons: [
                { id: "l_2_1", title: "Single Operator Drills", duration: "11:42", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" },
                { id: "l_2_2", title: "2-, 3- and 4-Man Formations", duration: "18:05", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4" },
                { id: "l_2_3", title: "Embus / Debus & Vehicle Cover", duration: "13:28", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4" },
            ],
        },
        {
            stage: "Stage 3: Operations & Principal Handling",
            lessons: [
                { id: "l_3_1", title: "Advance Reconnaissance", duration: "21:14", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4" },
                { id: "l_3_2", title: "Hotel & Venue Security", duration: "19:33", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4" },
                { id: "l_3_3", title: "Attack Recognition & Response", duration: "24:09", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4" },
            ],
        },
    ],
    c_002: [
        {
            stage: "Stage 1: Digital Hygiene Basics",
            lessons: [
                { id: "l_a", title: "Threat Landscape Today", duration: "06:10", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" },
                { id: "l_b", title: "Phishing & Social Engineering", duration: "12:40", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4" },
            ],
        },
        {
            stage: "Stage 2: Hardening the Operator",
            lessons: [
                { id: "l_c", title: "Encrypted Comms & MFA", duration: "14:22", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" },
                { id: "l_d", title: "Device & Travel OPSEC", duration: "16:01", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4" },
            ],
        },
    ],
    c_003: [
        {
            stage: "Stage 1: Pre-Trip Planning",
            lessons: [
                { id: "l_t1", title: "Country Risk Briefs", duration: "09:00", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4" },
                { id: "l_t2", title: "Travel Document Hygiene", duration: "08:22", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4" },
            ],
        },
        {
            stage: "Stage 2: On The Ground",
            lessons: [
                { id: "l_t3", title: "Hotel Security & Room Drills", duration: "12:11", completed: true, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4" },
                { id: "l_t4", title: "Situational Awareness Patterns", duration: "17:49", completed: false, video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4" },
            ],
        },
    ],
};

// Default curriculum fallback
export function getCurriculum(courseId) {
    return curricula[courseId] || curricula.c_001;
}

// Quizzes keyed by course id
export const quizzes = {
    c_001: {
        id: "q_001",
        courseId: "c_001",
        title: "Close Protection Foundations Quiz",
        questions: [
            {
                id: "q1",
                text: "In a 4-man CP foot formation, the operator positioned forward of the principal is typically known as the:",
                options: ["Tail Man", "Point Man", "Flank Man", "Sweeper"],
                correctIndex: 1,
            },
            {
                id: "q2",
                text: "What is the PRIMARY purpose of an advance party?",
                options: [
                    "Carry the principal's luggage",
                    "Negotiate with venue staff",
                    "Reconnoitre the route and destination ahead of the principal's arrival",
                    "Train local security personnel",
                ],
                correctIndex: 2,
            },
            {
                id: "q3",
                text: "When confronted with an immediate close-quarters attack, the CP operator's first priority is to:",
                options: ["Engage the threat", "Protect, evacuate and cover the principal", "Call law enforcement", "Identify the attacker"],
                correctIndex: 1,
            },
            {
                id: "q4",
                text: "Which acronym is commonly used to remember critical information during a threat assessment briefing?",
                options: ["SMEAC", "STOP", "ABCDE", "OODA"],
                correctIndex: 0,
            },
            {
                id: "q5",
                text: "Effective embus/debus drills focus primarily on:",
                options: [
                    "Speed of vehicle entry/exit and minimising principal exposure",
                    "Looking professional",
                    "Saving fuel costs",
                    "Photographing the surroundings",
                ],
                correctIndex: 0,
            },
        ],
    },
};

export function getQuiz(courseId) {
    return quizzes[courseId] || quizzes.c_001;
}

// Weekly hours learned data for charts
export const weeklyHours = [
    { day: "Mon", completed: 3.2, inProgress: 0.8 },
    { day: "Tue", completed: 2.8, inProgress: 1.4 },
    { day: "Wed", completed: 4.6, inProgress: 1.2 },
    { day: "Thu", completed: 4.2, inProgress: 0.5 },
    { day: "Fri", completed: 3.9, inProgress: 1.1 },
    { day: "Sat", completed: 4.8, inProgress: 0.9 },
    { day: "Sun", completed: 5.4, inProgress: 1.3 },
    { day: "Mon", completed: 5.9, inProgress: 0.4 },
];

export const goals = [
    { id: "g1", type: "Course Completion", title: "Achieve CP Operator Level 3", description: "Complete the Close Protection Foundations course and pass the assessment.", progress: 75, due: "12 days" },
    { id: "g2", type: "Daily Habit", title: "30 Mins of OSINT Practice", description: "Run a fresh OSINT exercise on a chosen target every weekday.", progress: 40, streak: "8 days" },
    { id: "g3", type: "Skill Mastery", title: "Pass FPOS-I Tactical First Aid", description: "Complete first aid course and re-certify by end of quarter.", progress: 18, due: "21 days" },
];

export const recentlyCompleted = ["Counter-Terrorism Awareness", "Travel Risk Management", "Conflict Management & De-escalation"];

export const userPerformance = [
    { name: "Jacob Jones", course: "Close Protection Operations", progress: 95, score: "9.8/10", lastActive: "2 hours ago", avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&auto=format" },
    { name: "Jane Cooper", course: "Cybersecurity Fundamentals", progress: 82, score: "9.1/10", lastActive: "5 hours ago", avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop&auto=format" },
    { name: "Cody Fisher", course: "HEAT Programme", progress: 65, score: "7.5/10", lastActive: "Yesterday", avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200&h=200&fit=crop&auto=format" },
    { name: "Kristin Watson", course: "Maritime Security Operations", progress: 48, score: "6.9/10", lastActive: "2 days ago", avatar: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=200&h=200&fit=crop&auto=format" },
    { name: "Wade Warren", course: "Defensive & Evasive Driving", progress: 91, score: "9.4/10", lastActive: "1 hour ago", avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&auto=format" },
];

// Customers (admin view)
export const customers = [
    { id: "u_101", name: "Jacob Jones", email: "jacob@globalshield.com", avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&auto=format", coursesPurchased: 3, totalProgress: 78, status: "Active", joined: "2024-08-12", spent: 1289.97 },
    { id: "u_102", name: "Jane Cooper", email: "jane.c@aegisrisk.io", avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop&auto=format", coursesPurchased: 5, totalProgress: 92, status: "Active", joined: "2024-06-30", spent: 2314.95 },
    { id: "u_103", name: "Cody Fisher", email: "cody.f@hartlandgroup.com", avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200&h=200&fit=crop&auto=format", coursesPurchased: 2, totalProgress: 54, status: "Active", joined: "2025-01-04", spent: 749.98 },
    { id: "u_104", name: "Kristin Watson", email: "k.watson@oceanguard.co", avatar: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=200&h=200&fit=crop&auto=format", coursesPurchased: 1, totalProgress: 22, status: "Inactive", joined: "2025-02-19", spent: 499.00 },
    { id: "u_105", name: "Wade Warren", email: "wade.w@brandtype.io", avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&auto=format", coursesPurchased: 4, totalProgress: 88, status: "Active", joined: "2024-11-22", spent: 1944.96 },
    { id: "u_106", name: "Esther Howard", email: "esther@bluemountain.io", avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&h=200&fit=crop&auto=format", coursesPurchased: 6, totalProgress: 71, status: "Active", joined: "2024-04-15", spent: 2879.94 },
    { id: "u_107", name: "Robert Fox", email: "rfox@privateclient.com", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&auto=format", coursesPurchased: 2, totalProgress: 36, status: "Pending", joined: "2025-01-30", spent: 689.98 },
    { id: "u_108", name: "Leslie Alexander", email: "leslie@bluemountain.io", avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&auto=format", coursesPurchased: 3, totalProgress: 61, status: "Active", joined: "2024-09-12", spent: 947.97 },
];

// Certificates
export const certificates = [
    { id: "cert_001", studentId: "u_001", studentName: "Leslie Alexander", courseId: "c_014", courseTitle: "Counter-Terrorism Awareness", issuedAt: "2026-01-15", instructor: "Nige Thomas", grade: "A+", code: "BMG-2026-0001" },
    { id: "cert_002", studentId: "u_001", studentName: "Leslie Alexander", courseId: "c_023", courseTitle: "Travel Risk Management", issuedAt: "2025-11-22", instructor: "Nige Thomas", grade: "A", code: "BMG-2025-0227" },
    { id: "cert_003", studentId: "u_001", studentName: "Leslie Alexander", courseId: "c_011", courseTitle: "Conflict Management & De-escalation", issuedAt: "2025-08-04", instructor: "Nige Thomas", grade: "A-", code: "BMG-2025-0143" },
];

// Admin overview stats
export const adminStats = {
    totalStudents: 12482,
    totalRevenue: 1284921,
    activeEnrollments: 8204,
    coursesPublished: 24,
    studentsTrend: 12.4,
    revenueTrend: 8.7,
    enrollmentsTrend: 15.2,
    coursesTrend: 4.1,
};

export const recentActivity = [
    { type: "enrollment", text: "Jane Cooper enrolled in Cybersecurity Fundamentals", time: "2m ago" },
    { type: "completion", text: "Jacob Jones completed Close Protection Operations", time: "12m ago" },
    { type: "purchase", text: "Wade Warren purchased Defensive & Evasive Driving", time: "34m ago" },
    { type: "certificate", text: "Certificate issued to Esther Howard for Travel Risk Management", time: "1h ago" },
    { type: "enrollment", text: "Robert Fox enrolled in HEAT Programme", time: "2h ago" },
    { type: "completion", text: "Kristin Watson completed Module 3 of OSINT for Operators", time: "3h ago" },
];

export const notifications = {
    emailNotifications: true,
    pushNotifications: false,
    monthlyReports: true,
};
